import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import CoverSpiralPicker from "./cover-spiral-picker";
import { getValidSpirals } from "ui/store";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    validSpirals: getValidSpirals(state),
    calendar: getCalendar(state),
    Binding_Spiral: getResource(state, { key: "Binding_Spiral" }),
});

const mapDispatchToProps = {
    ...actionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverSpiralPicker);
